import {
  viewHeight
} from "./common/_common";
/*
import {
  countDownFunc,
  resizeFunc
} from "./common/_countDown";
*/
import {
  headerNavFunc,
  headerScrollFunc
} from "./common/_header";
import {
  modalFunc
} from "./common/_modal";
import {
  viewAllFunc
} from "./common/_moreNews";
import {
  pageMoveAnkerFunc,
  pageMoveIdAnkerFunc
} from "./common/_pageLink";
import {
  sliderFunc
} from "./common/_slider";
import {
  heightLine,
  heightLineSetFunc,
  heightLineFunc
} from "./common/_heightLine";
//* ---------------------------------------
//通常実行
//-------------------------------------- */
let setTimer = false;
let topPage = $('#index').length;
//* ----------------------------------------
//window実行
//--------------------------------------- */

////// ロード時
$(window).on('load', function () {
  viewHeight();
  headerNavFunc();
  headerScrollFunc();
  pageMoveAnkerFunc();
  pageMoveIdAnkerFunc();
  heightLine();
  heightLineSetFunc();
  if (topPage) {
    //countDownFunc();
    viewAllFunc();
    modalFunc();
    sliderFunc();
  }
});

// リサイズ時
/*リサイズ後,200msで発火する設定*/
$(window).on('resize', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
    viewHeight();
    //resizeFunc();
    heightLineSetFunc();
  }, 200);
});

// スクロール時
$(window).on('scroll', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {

  }, 200);
});
